const state = {
  lines: [
    {
      code: "west",
      title: "Metro West"
    },
    {
      code: "greaterWest",
      title: "Greater West"
    },
    {
      code: "northWest",
      title: "NorthWest"
    },
    {
      code: "citySouthWest",
      title: "City and SouthWest"
    },
    {
      code: "futureProjects",
      title: "Future Projects"
    }
  ],
  stations: {
    west: [
      "Example Station X",
      "Pyrmont",
      "The Bays Precinct",
      "Five Dock",
      "Burwood North",
      "North Strathfield",
      "Olympic Park",
      "Silverwater",
      "Clyde",
      "Parramatta",
      "Westmead"
    ],
    greaterWest: [],
    northWest: [],
    citySouthWest: [],
    futureProjects: []
  },
  selectedLine: {},
  selectedStations: [],
  zones: [
    {
      code: "designportal",
      title: "Design Portal",
      icon: "img/icons/sidebaricons/DesignPortal_icon_dark.png",
      path: "/designportal"
    },
    {
      code: "designreview",
      title: "Design Review",
      icon: "img/icons/sidebaricons/DesignReview_icon_dark.png",
      path: "/designreview"
    },
    {
      code: "lessonslearned",
      title: "Lessons Learned",
      icon: "img/icons/sidebaricons/LessonLearned_icon_dark.png",
      path: "/lessonslearned"
    },
    {
      code: "projectdashboard",
      title: "Project Dashboard",
      icon: "img/icons/sidebaricons/ProjectDashboard_icon_dark.png",
      path: "/projectdashboard"
    },
    {
      code: "culturediversity",
      title: "Culture and Diversity",
      icon: "img/icons/sidebaricons/CultureDiversity_icon_dark.png",
      path: "/culturediversity"
    },
    {
      code: "digital",
      title: "Digital",
      icon: "img/icons/sidebaricons/Digital_icon_dark.png",
      path: "/digital"
    },
    // {
    //   code: "projectreview",
    //   title: "360 Project Review",
    //   icon: "img/icons/sidebaricons/360Project_icon_dark.png",
    //   path: "/360projectreview"
    // },
    // {
    //   code: "kpitracker",
    //   title: "KPI Tracker",
    //   icon: "img/icons/sidebaricons/KPI_icon_dark.png",
    //   path: "/kpitracker"
    // },
    // {
    //   code: "managementresources",
    //   title: "Management Resources",
    //   icon: "img/icons/sidebaricons/ManagementResources_icon_dark.png",
    //   path: "/managementresources"
    // },
    // {
    //   code: "communityportal",
    //   title: "Community Portal",
    //   icon: "img/icons/sidebaricons/CommunityPortal_icon_dark.png",
    //   path: "/communityportal"
    // }
  ],
  categories: {
    designportal: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    designreview: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    lessonslearned: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    projectdashboard: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    culturediversity: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    digital: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    projectreview: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    kpitracker: [
      "Monthly",
      "Weekly",
      "Live"
    ],
    managementresources: [
      "Management Plans",
      "Passport (Inductions)",
      "Resource Management",
      "Planning and Scheduling",
      "Change Control",
      "Health and Safety"
    ],
    communityportal: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ]
  },
  selectedZone: {},
  selectedCategories: [],
  counter: 0,
  activeTabFlags: {
    insightSection: false,
    bim360Section: false,
    GISDashboardSection: false,
    GISPortalSection: false,
    simulationSection: false,
    opsSection: false,
    teamBinderSection: false
  },
  portfolios: [
    {
      code: "portfolio",
      title: "West Package"
    }

  ],
  projects: {
    portfolio: [
      "The Bays",
      "Five Dock",
      "Burwood North",
      "North Strathfield",
      "Westmead"

      // "ESC"
      // "Tottenham to Albury (T2A)",
      // "Albury to Illabo (A2I)",
      // "Illabo to Stockinbingal (I2S)",
      // "Stockinbingal to Parkes (S2P)",
      // "Parkes to Narromine (P2N)",
      // "Narromine to Narrabri (N2N)",
      // "Narrabri to North Star (N2NS)",
      // "North Star to Border (NS2B)",
      // "Border to Gowrie (B2G)",
      // "Gowrie to Helidon (G2H)",
      // "Helidon to Calvert (H2C)",
      // "Calvert to Kaguru (C2K)",
      // "Kaguru to Acacia Ridge / Bromelton (K2AR)"
    ]
  },
  projectTabs: [
    {
      zoneCode: "designportal",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "designreview",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "lessonslearned",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "projectdashboard",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "culturediversity",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "digital",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "projectreview",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "kpitracker",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "managementresources",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "communityportal",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "INSIGHT",
              imgUrl: "img/assets/tabs/InsightTab.png",
              // url: "https://comment-envi-tool.geodemosolutions.com/"
            },
            {
              title: "BIM",
              url: "",
              imgUrl: "img/assets/tabs/BIMTab.png"
            },
            // {
            //   title: "2D VIEW",
            //   imgUrl: "img/assets/tabs/2DViewTab.png",
            //   url: "https://srla-wab-app.geodemosolutions.com/"
            // },
            {
              title: "GIS",
              imgUrl: "img/assets/tabs/GISTab.jpg",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              url: "",
              imgUrl: "img/assets/tabs/DesignReviewSMTab.png"
            },
            {
              title: "ISSUE MANAGEMENT",
              url: "",
              imgUrl: "img/assets/tabs/IssueManagementTab.png"
            },
            {
              title: "SITE VISUALISATION",
              url: "",
              imgUrl: "img/assets/tabs/SiteVisualisationTab.png"
            }
          ]
        },
      ]
    },
  ],
  selectedPortfolio: {},
  selectedProjects: [],
  currentSelectedProject: "",
  currentSelectedSubCategory: "",
  currentSelectedProjectTab: {
    category: "",
    tabs: [
    ]
  }
}

function initialState() {
  return {
    lines: [
      {
        code: "west",
        title: "Metro West"
      },
      {
        code: "greaterWest",
        title: "Greater West"
      },
      {
        code: "northWest",
        title: "NorthWest"
      },
      {
        code: "citySouthWest",
        title: "City and SouthWest"
      },
      {
        code: "futureProjects",
        title: "Future Projects"
      }
    ],
    stations: {
      west: [
        "Example Station X",
        "Pyrmont",
        "The Bays Precinct",
        "Five Dock",
        "Burwood North",
        "North Strathfield",
        "Olympic Park",
        "Silverwater",
        "Clyde",
        "Parramatta",
        "Westmead"
      ],
      greaterWest: [],
      northWest: [],
      citySouthWest: [],
      futureProjects: []
    },
    selectedLine: {},
    selectedStations: [],
    zones: [
      {
        code: "designportal",
        title: "Design Portal",
        icon: "img/icons/sidebaricons/DesignPortal_icon_dark.png",
        path: "/designportal"
      },
      {
        code: "designreview",
        title: "Design Review",
        icon: "img/icons/sidebaricons/DesignReview_icon_dark.png",
        path: "/designreview"
      },
      {
        code: "lessonslearned",
        title: "Lessons Learned",
        icon: "img/icons/sidebaricons/LessonLearned_icon_dark.png",
        path: "/lessonslearned"
      },
      {
        code: "projectdashboard",
        title: "Project Dashboard",
        icon: "img/icons/sidebaricons/ProjectDashboard_icon_dark.png",
        path: "/projectdashboard"
      },
      {
        code: "culturediversity",
        title: "Culture and Diversity",
        icon: "img/icons/sidebaricons/CultureDiversity_icon_dark.png",
        path: "/culturediversity"
      },
      {
        code: "digital",
        title: "Digital",
        icon: "img/icons/sidebaricons/Digital_icon_dark.png",
        path: "/digital"
      },
      // {
      //   code: "projectreview",
      //   title: "360 Project Review",
      //   icon: "img/icons/sidebaricons/360Project_icon_dark.png",
      //   path: "/360projectreview"
      // },
      // {
      //   code: "kpitracker",
      //   title: "KPI Tracker",
      //   icon: "img/icons/sidebaricons/KPI_icon_dark.png",
      //   path: "/kpitracker"
      // },
      // {
      //   code: "managementresources",
      //   title: "Management Resources",
      //   icon: "img/icons/sidebaricons/ManagementResources_icon_dark.png",
      //   path: "/managementresources"
      // },
      // {
      //   code: "communityportal",
      //   title: "Community Portal",
      //   icon: "img/icons/sidebaricons/CommunityPortal_icon_dark.png",
      //   path: "/communityportal"
      // }
    ],
    categories: {
      designportal: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      designreview: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      lessonslearned: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      projectdashboard: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      culturediversity: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      digital: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      projectreview: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      kpitracker: [
        "Monthly",
        "Weekly",
        "Live"
      ],
      managementresources: [
        "Management Plans",
        "Passport (Inductions)",
        "Resource Management",
        "Planning and Scheduling",
        "Change Control",
        "Health and Safety"
      ],
      communityportal: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ]
    },
    selectedZone: {},
    selectedCategories: [],
    counter: 0,
    activeTabFlags: {
      insightSection: false,
      bim360Section: false,
      GISDashboardSection: false,
      GISPortalSection: false,
      simulationSection: false,
      opsSection: false,
      teamBinderSection: false
    },
    portfolios: [
      {
        code: "portfolio",
        title: "Portfolio"
      }
      // {
      //   code: "passenger_service",
      //   title: "Passenger Services"
      // },
      // {
      //   code: "other_lines",
      //   title: "Other Lines"
      // },
      // {
      //   code: "closed_lines",
      //   title: "Closed Lines"
      // },

    ],
    projects: {
      portfolio: [
        "ESC"
        // "Tottenham to Albury (T2A)",
        // "Albury to Illabo (A2I)",
        // "Illabo to Stockinbingal (I2S)",
        // "Stockinbingal to Parkes (S2P)",
        // "Parkes to Narromine (P2N)",
        // "Narromine to Narrabri (N2N)",
        // "Narrabri to North Star (N2NS)",
        // "North Star to Border (NS2B)",
        // "Border to Gowrie (B2G)",
        // "Gowrie to Helidon (G2H)",
        // "Helidon to Calvert (H2C)",
        // "Calvert to Kaguru (C2K)",
        // "Kaguru to Acacia Ridge / Bromelton (K2AR)"
      ]
      // passenger_service: [
      //   "Muswellbrook",
      //   "Station A",
      //   "Station B",
      //   "Station C",
      //   "Station D"
      // ],
      // other_lines: [
      //   "Station E",
      //   "Station F",
      //   "Station G",
      //   "Station H",
      //   "Station I"
      // ],
      // closed_lines: [
      //   "Station J",
      //   "Station K",
      //   "Station L",
      //   "Station M",
      //   "Station N"
      // ]
    },
    projectTabs: [
      {
        zoneCode: "designportal",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                imgUrl: "img/assets/tabs/InsightModified.png",
                // url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "designreview",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "lessonslearned",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "projectdashboard",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "culturediversity",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "digital",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "projectreview",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "kpitracker",
        items: [
          {
            category: "Monthly",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Weekly",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Live",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "managementresources",
        items: [
          {
            category: "Management Plans",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Passport (Inductions)",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resource Management",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Planning and Scheduling",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Change Control",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Health and Safety",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "communityportal",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Resourcing",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Design",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Construction",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
          {
            category: "Reporting and Analytics",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://comment-envi-tool.geodemosolutions.com/"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "",
                imgUrl: "img/assets/tabs/InfoExchangeTab.png"
              },
              {
                title: "2D VIEW",
                imgUrl: "img/assets/tabs/2DViewTab.png",
                url: "https://srla-wab-app.geodemosolutions.com/"
              },
              {
                title: "3D VIEW",
                imgUrl: "img/assets/tabs/3DViewTab.png",
                url: ""
              },
              {
                title: "DESIGN REVIEW",
                url: "",
                imgUrl: "img/assets/tabs/DesignReviewTab.png"
              },
              {
                title: "DASHBOARD",
                url: "",
                imgUrl: "img/assets/tabs/dashboard_tab.png"
              },
              {
                title: "360 Project View",
                url: "https://tap5.geodemosolutions.com/"
              }
            ]
          },
        ]
      },
    ],
    selectedPortfolio: {},
    selectedProjects: [],
    currentSelectedProject: "",
    currentSelectedSubCategory: "",
    currentSelectedProjectTab: {
      category: "",
      tabs: [
      ]
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setCurrentSelectedProject(state, payload) {
    state.currentSelectedProject = payload
  },
  setCurrentSelectedProjectTab(state, payload) {
    state.currentSelectedProjectTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
